import { CheckoutState } from '../state';
import {
    isAndroidWebView,
    isFacebookWebView,
    isInstagramWebView,
    isLinkedInWebView,
} from '../utils/browser';
import { isEventbriteTLD } from './app';
import { isGooglePaySplitTreatmentEnabled } from './splitio';

export const isGooglePayEnabled = (state: CheckoutState) => {
    const { userAgent } = window.navigator;
    if (
        isAndroidWebView(userAgent) ||
        isFacebookWebView(userAgent) ||
        isInstagramWebView(userAgent) ||
        isLinkedInWebView(userAgent) ||
        !isEventbriteTLD(state)
    ) {
        return false;
    }

    return isGooglePaySplitTreatmentEnabled(state);
};

export const getGooglePayInstance = (state: CheckoutState) =>
    state.googlePay.googlePayInstance;

export const getGooglePayPaymentRequest = (state: CheckoutState) =>
    state.googlePay.googlePayPaymentRequest;
